import { LitElement, html } from 'lit';

export default class SotbitTabNavMoreButton extends LitElement {
    static properties = {
        open: { type: Boolean },
    };

    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

    render() {
        return html`
            <sotbit-tab-nav-button icon="${this.open ? 'close' : 'more-horiz'}">
                <slot></slot>
            </sotbit-tab-nav-button>
        `;
    }
}
